import React from 'react';
import PropTypes from 'prop-types';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Link, withRouter } from 'react-router';
import _ from 'lodash';

import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import MoreHorizIcon from 'material-ui/svg-icons/navigation/more-horiz';
import IconEdit from 'material-ui/svg-icons/content/create';
import IconDelete from 'material-ui/svg-icons/action/delete';
import Download from 'material-ui/svg-icons/content/font-download';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import classes from './Staff.scss';

import { DetailField } from '../../../components/DetailField/DetailField';
import ContactCard from '../../../components/ContactCard/ContactCard';
import FileTable from '../../../components/FileTable/FileTable';
import ProjectTable from '../../../components/ProjectTable/ProjectTable';
import TaskList from '../../../components/TaskList';
import ActivityTableEmbed from '../../../components/ActivityTableEmbed/ActivityTableEmbed';
import peopleStrings from '../../../locales/people/de.json';
import contactDetailsStrings from '../../../locales/contactDetails/de.json';
import { renderTabCount } from '../../../helpers/renderTabCount';
import { Address } from '../../../components/Address/Address';
import { simplApiUrlPure, simplAvatarUrl } from '../../../api/simplApi';
import FormFileUpload from '../../../components/FormFileUpload/FormFileUpload';
import { getBirthdayFromMeta } from '../../../helpers/getBirthdayFromMeta';

class Staff extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      alert: null,
      selectedIndex: 0,
    };
  }

  componentWillMount() {
    this.props.setStaff(this.props.params.staff);
  }

  componentDidMount() {
    this.props.fetchStaff(this.props.params.staff);
  }

  handleSelect = index => {
    this.setState({ selectedIndex: index });
  };

  handleAlertClose = () => {
    this.setState({
      alert: null,
    });
  };

  renderHeader = () => (
    <header>
      <ul className="breadcrumbs">
        <li>
          <Link to="/staff" activeClassName={classes.activeRoute}>
            {this.props.staffCount} Mitarbeiter
          </Link>
        </li>
        <li>
          {this.props.staff.name}
          {this.props.staff.deleted_at === null ? (
            ''
          ) : (
            <span className="deletedTag">gelöscht</span>
          )}
        </li>
      </ul>
      <IconMenu
        iconButtonElement={
          <IconButton>
            <MoreHorizIcon />
          </IconButton>
        }
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        targetOrigin={{ horizontal: 'right', vertical: 'top' }}
        className="overflow-right"
      >
        <MenuItem
          primaryText="Mitarbeiter bearbeiten"
          leftIcon={<IconEdit className="svg-icon-primary" />}
          key="editStaff"
          className="menu-primary"
          onClick={() => {
            this.props.setStaffForm(this.props.staff.id);
          }}
        />

        <MenuItem
          primaryText="Mitarbeiter löschen"
          leftIcon={
            <IconDelete className="svg-icon-primary svg-icon-warning" />
          }
          key="delStaff"
          className="menu-primary"
          onClick={() => {
            this.setState({
              alert: (
                <Dialog
                  actions={[
                    <FlatButton
                      label="Abbrechen"
                      primary
                      onTouchTap={this.handleAlertClose}
                    />,
                    <FlatButton
                      label="Löschen"
                      primary
                      onTouchTap={() => {
                        this.handleAlertClose();
                        this.props.deleteStaff(this.props.staff.id); // this.props.push('/staff');
                        this.props.router.push('/staff');
                      }}
                    />,
                  ]}
                  modal={false}
                  open
                  onRequestClose={this.handleAlertClose}
                >
                  Mitarbeiter wirklich löschen?
                </Dialog>
              ),
            });
          }}
        />

        <MenuItem
          primaryText="Mitarbeiter als PDF exportieren"
          leftIcon={<Download className="svg-icon" />}
          key="downloadStaff"
          className="menu-primary"
          onClick={() => {
            const id =
              typeof this.props.staff.simpl_account === 'string'
                ? this.props.staff.simpl_account
                : this.props.staff.simpl_account.id;
            window.open(
              simplApiUrlPure(
                `export/pdf/staff/${id}/${this.props.staff.id}/${this.props.staff.linkHash}`,
              ),
              '_blank',
            );
          }}
        />
      </IconMenu>
      {this.state.alert}
    </header>
  );
  renderContacts = () => {
    const contacts = [];
    _.forOwn(this.props.persons, value => {
      // create new object that will be handled by griddle
      const email = _.find(value.contact_details, ['type', 'email']);
      const phone = _.find(value.contact_details, ['type', 'tel']);
      const position = _.find(value.meta, ['key', 'position']);
      contacts.push(
        <ContactCard
          name={value.name}
          number={phone ? phone.value : null}
          email={email ? email.value : null}
          position={position ? position.value : null}
          avatar={value.avatar_url}
          key={`contactcard_${value.id}`}
        />,
      );
    });
    if (contacts.length === 0) {
      return <div />;
    }
    return (
      <section>
        <h2>Kontakte</h2>
        <div className="row">{contacts}</div>
      </section>
    );
  };
  renderContactDetails = () =>
    this.props.staff.contact_details.map(contactDetail => (
      <DetailField
        key={contactDetail.id}
        label={contactDetailsStrings[contactDetail.type]}
        content={contactDetail.value}
        extra={contactDetail.note}
      />
    ));
  renderPlaceDetails = () => {
    let placeDetails = [];
    placeDetails.push(
      <DetailField label="Abteilung" content={this.props.staff.meta.section} />,
    );
    placeDetails.push(
      <DetailField label="Gebäude" content={this.props.staff.meta.building} />,
    );
    placeDetails.push(
      <DetailField label="Stockwerk" content={this.props.staff.meta.floor} />,
    );
    placeDetails.push(
      <DetailField
        label="Zimmernummer"
        content={this.props.staff.meta.room_number}
      />,
    );
    if (placeDetails.length) {
      placeDetails = [
        <h2 key="detailed_place_header">Standortangaben</h2>,
        placeDetails,
      ];
    }
    return placeDetails;
  };
  renderContactDetails = () => {
    const details = [];
    if (typeof this.props.staff.contact_details !== 'undefined') {
      const sortedDetails = _.sortBy(this.props.staff.contact_details, [
        'sortedByType',
        'created_at',
      ]);

      sortedDetails.forEach(contactDetail => {
        details.push(
          <DetailField
            key={`contact_detail_${contactDetail.id}`}
            label={contactDetailsStrings[contactDetail.type]}
            content={contactDetail.value}
            extra={contactDetail.note}
          />,
        );
      });
    }
    return details;
  };
  renderOverview = () => {
    let address = '';
    if (
      typeof this.props.staff.addresses !== 'undefined' &&
      typeof this.props.staff.addresses[0] !== 'undefined' &&
      typeof this.props.staff.addresses[0].street !== 'undefined' &&
      this.props.staff.addresses[0].street !== null &&
      this.props.staff.addresses[0].street.length
    ) {
      address = (
        <div className="row overview">
          <div className="col-xs-12 col-sm-3">
            <label>Adresse</label>
          </div>
          <div className="col-xs-12 col-sm-9">
            <Address address={this.props.staff.addresses[0]} />
          </div>
        </div>
      );
    }

    const avatar = simplAvatarUrl(
      'staff',
      this.props.staff.id,
      128,
      128,
      'crop',
    );

    return (
      <div>
        <section>
          <h2>Allgemein</h2>
          <div className={classes.peopleMainInfo}>
            <div className={classes.peopleMainInfoLeft}>
              <DetailField
                label="Titel"
                content={this.props.staff.meta.salutation}
              />
              <DetailField label="Name" content={this.props.staff.name} />
              <DetailField label="E-Mail" content={this.props.staff.email} />
              <DetailField
                label="Position"
                content={this.props.staff.meta.position}
              />
              <DetailField
                label="Geschlecht"
                content={
                  this.props.staff.meta.gender
                    ? peopleStrings[this.props.staff.meta.gender.value]
                    : null
                }
              />
              <DetailField
                label="Geburtstag"
                content={getBirthdayFromMeta(this.props.staff.meta, true)}
              />
              <DetailField
                label="Bemerkungen"
                content={this.props.staff.meta.notes}
                className="notes"
              />
            </div>
            <div className={classes.peopleMainInfoRight}>
              <img src={avatar} alt={this.props.staff.name} />
            </div>
          </div>
        </section>

        <section>
          <h2>Anschrift & Kommunikation</h2>

          {address}

          {this.renderContactDetails()}

          {this.renderPlaceDetails()}
        </section>
      </div>
    );
  };
  render() {
    if (!this.props.staff || Object.keys(this.props.staff).length === 0) {
      // no data loaded yet
      return <div />;
    }

    Tabs.setUseDefaultStyles(false);
    return (
      <div
        className={
          this.props.staff.deleted_at === null
            ? 'wrapper details-view'
            : 'wrapper details-view deletedModel'
        }
      >
        {this.renderHeader()}
        <Tabs
          onSelect={this.handleSelect}
          selectedIndex={this.state.selectedIndex}
          className="content"
        >
          <TabList activeTabClassName="active">
            <Tab>
              <span>Details</span>
            </Tab>
            <Tab>
              <span>
                Eigene Aktivitäten {renderTabCount(this.props.activities)}
              </span>
            </Tab>
            <Tab>
              <span>
                Aktivitäten als Teilnehmer{' '}
                {renderTabCount(this.props.activitiesAsParticipant)}
              </span>
            </Tab>
            <Tab>
              <span>Projekte {renderTabCount(this.props.projects)}</span>
            </Tab>
            <Tab>
              <span>Aufgaben {renderTabCount(this.props.tasks)}</span>
            </Tab>
            <Tab>
              <span>Dateien {renderTabCount(this.props.files)}</span>
            </Tab>
          </TabList>

          <TabPanel>{this.renderOverview()}</TabPanel>
          <TabPanel>
            <ActivityTableEmbed
              activities={this.props.activities}
              staffs={this.props.staffs}
              compact
            />
          </TabPanel>
          <TabPanel>
            <ActivityTableEmbed
              activities={this.props.activitiesAsParticipant}
              staffs={this.props.staffs}
              compact
              asParticipant
            />
          </TabPanel>
          <TabPanel>
            <section>
              <h2>{renderTabCount(this.props.projects, true)} Projekte</h2>
            </section>
            <section className="no-padding">
              <ProjectTable
                projects={this.props.projects}
                staffs={this.props.staffs}
              />
            </section>
          </TabPanel>
          <TabPanel>
            <section>
              <h2>
                {renderTabCount(this.props.tasks, true)} Aufgaben wurden{' '}
                {this.props.staff.name} zugewiesen
              </h2>
            </section>
            <TaskList
              tasks={this.props.tasks}
              showTaskForm
              assigneeId={this.props.staff.id}
              showFutureDates
            />
          </TabPanel>
          <TabPanel>
            <section>
              <h2>{renderTabCount(this.props.files, true)} Dateien</h2>
            </section>
            <section className="no-padding">
              <FileTable
                files={this.props.files}
                deleteFile={this.props.deleteFile}
              />
            </section>
          </TabPanel>
        </Tabs>

        <FormFileUpload
          attachableId={this.props.staff.id}
          attachableType="App\Staff"
          files={[]}
          onUpdate={() => {
            this.props.fetchStaff(this.props.staff.id);
          }}
          invisible
          disabled={this.props.formOpen}
        />
      </div>
    );
  }
}
Staff.propTypes = {
  fetchStaff: PropTypes.func.isRequired,
  setStaff: PropTypes.func.isRequired,
  setStaffForm: PropTypes.func.isRequired,
  deleteStaff: PropTypes.func.isRequired,
  deleteFile: PropTypes.func.isRequired,
  push: PropTypes.func.isRequired,
  staff: PropTypes.object,
  staffCount: PropTypes.number,
  activities: PropTypes.array.isRequired,
  activitiesAsParticipant: PropTypes.array.isRequired,
  staffs: PropTypes.array.isRequired,
  files: PropTypes.array,
  tasks: PropTypes.array,
  persons: PropTypes.array,
  projects: PropTypes.array,
  params: PropTypes.object,
  router: PropTypes.object,
  formOpen: PropTypes.bool,
};
Staff.defaultProps = {
  staff: {},
  staffCount: 0,
  files: [],
  tasks: [],
  persons: [],
  projects: [],
  params: {},
};
export default withRouter(Staff);



// WEBPACK FOOTER //
// ./src/routes/StaffDetail/components/Staff.js